<template>
  <div class="vb-result-view">
    <b-container fluid="lg">
      <trigger-booking-engine :is_open="is_open" @toggle="is_open = $event" />
      <booking-engine :is_open="is_open" @search="search()" />
      <section class="section section--loader" v-if="searching">
        <loader size="large" :show_timing_slot="true" />
      </section>
      <section class="section" v-if="!searching">
        <div v-if="last_search !== current_search">
          <b-alert show variant="warning">Attenzione, hai cambiato i criteri di ricerca ma non hai aggiornato i risultati. Clicca su Cerca.</b-alert>
          <br><br>
        </div>
        <results />
      </section>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { alpitour_service_handler } from '@alpitour/services'
import { endpoints_keys } from '@alpitour/resources'
import { build_search_request } from '@alpitour/components/blocks/booking-engine/logic'
import { custom_event, decode_parameters } from '@utilities'
import Results from '@alpitour/components/views/content-blocks/results.vue'
import TriggerBookingEngine from '@components/atoms/trigger-booking-engine.vue'

export default {
  name: 'results-view',

  components: {
    results: Results,
    'trigger-booking-engine': TriggerBookingEngine,
  },

  data() {
    return {
      is_open: false,
    }
  },

  computed: {
    // global state keys
    ...mapState([
      'searching',
    ]),
    // module state keys
    ...mapState(
      'liveat', [
      'last_search',
      'current_search',
      'trigger_search',
    ]),
  },

  mounted() {
    if (this.trigger_search) this.search()
  },

  methods: {
    search() {
      this.is_open = false
      this.$store.commit('searching', true)
      this.$store.commit('liveat/trigger_search', false)

      let timestamp_start = (new Date()).getTime(),
        search_params = decode_parameters(this.last_search),
        request_body = build_search_request(search_params)

      alpitour_service_handler(
        endpoints_keys.search,
        request_body,
      ).then(
        (success) => {
          const { products: raw_products = [], statics = {}, keyds = [] } = (success.data && success.data.data) || {}
          const products = raw_products.sort((a, b) => {
            return a.keyd.localeCompare(b.keyd)
            || a.pid.localeCompare(b.pid)
            || (a.departureAirportCode || '').localeCompare(b.departureAirportCode || '')
            || a.departureDate.localeCompare(b.departureDate)
            || a.room.localeCompare(b.room)
            || a.accommodation.localeCompare(b.accommodation)
            || a.price.localeCompare(b.price)
          })
          
          // delay controllato per evitare ricerche troppo veloci
          let gap = (new Date()).getTime() - timestamp_start,
            min_gap = 1500,
            delay = gap < min_gap ? (min_gap - gap) : 0
          setTimeout(() => {
            this.$store.commit('liveat/products', products)
            this.$store.commit('liveat/statics', statics)
            this.$store.commit('liveat/keyds', keyds)
            this.$store.commit('searching', false)
          }, delay)

          custom_event('search_keyd', search_params.keyd, (success.data.data.products.length), 'results_count')
          custom_event('search_date', search_params.departure_date, (success.data.data.products.length), 'results_count')
          custom_event('search_nights', search_params.nights, (success.data.data.products.length), 'results_count')
          custom_event('search_occupancy', success.data.data.occupancy, (success.data.data.products.length), 'results_count')
        }
      ).catch(() => {
        this.$store.commit('searching', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>